import { useMutation } from '@apollo/client/react'
import * as Sentry from '@sentry/react'
import { toast } from 'sonner'
import {
  PortalBusinessPackagesDocument,
  PortalRemovePackageFromBusinessDocument,
  type PortalRemovePackageFromBusinessMutation,
  type PortalRemovePackageFromBusinessMutationVariables,
} from '@/graphql/generated/graphql'

/**
 * Baja de un servicio contratado. `packageBusinessServiceId` es el `id` de la
 * fila de `portalBusinessPackages` (no el `packageServiceId` del catálogo).
 * Refetch para refrescar la lista. El llamador muestra el aviso de vigencia.
 */
export function useRemovePackageFromBusiness(businessId: string) {
  const [mutate, { loading, error }] = useMutation<
    PortalRemovePackageFromBusinessMutation,
    PortalRemovePackageFromBusinessMutationVariables
  >(PortalRemovePackageFromBusinessDocument, {
    refetchQueries: [
      { query: PortalBusinessPackagesDocument, variables: { businessId } },
    ],
    awaitRefetchQueries: true,
    onError: (err) => {
      Sentry.captureException(err, {
        tags: { operation: 'PortalRemovePackageFromBusiness' },
      })
      toast.error('No se pudo quitar el servicio', { description: err.message })
    },
  })

  const removePackage = async (packageBusinessServiceId: number) => {
    const result = await mutate({ variables: { packageBusinessServiceId } })
    return result.data?.portalRemovePackageFromBusiness ?? false
  }

  return { removePackage, loading, error }
}
